import React, { useState, useEffect } from 'react';

const TutorialButton = () => {
  const [showPopup, setShowPopup] = useState(false);

  const openPopup = () => setShowPopup(true);
  const closePopup = () => setShowPopup(false);

  // Close popup when clicking outside
  useEffect(() => {
    const handleEscape = (e:any) => {
      if (e.key === 'Escape') {
        closePopup();
      }
    };

    if (showPopup) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [showPopup]);

  const buttonStyles = {
    background: 'linear-gradient(135deg, #8B5CF6 0%, #A855F7 50%, #9333EA 100%)',
    border: 'none',
    borderRadius: '12px',
    padding: '14px 28px',
    color: 'white',
    fontSize: '16px',
    fontWeight: '600',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    boxShadow: '0 4px 20px rgba(139, 92, 246, 0.3)',
    textDecoration: 'none',
    position: 'relative',
    overflow: 'hidden',
    minWidth: '180px',
    justifyContent: 'center'
  };

  const playIconStyles = {
    width: 0,
    height: 0,
    borderLeft: '12px solid white',
    borderTop: '8px solid transparent',
    borderBottom: '8px solid transparent',
    marginLeft: '2px'
  };

  const shineStyles = {
    position: 'absolute',
    top: 0,
    left: '-100%',
    width: '100%',
    height: '100%',
    background: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent)',
    transition: 'left 0.5s',
    pointerEvents: 'none'
  };

  return (
    <>
      <style dangerouslySetInnerHTML={{
        __html: `
          @keyframes pulse-glow {
            0%, 100% {
              box-shadow: 0 4px 20px rgba(139, 92, 246, 0.3);
            }
            50% {
              box-shadow: 0 4px 25px rgba(139, 92, 246, 0.5);
            }
          }
          
          @keyframes bounce-in {
            0% {
              transform: scale(0.3);
              opacity: 0;
            }
            50% {
              transform: scale(1.05);
            }
            70% {
              transform: scale(0.9);
            }
            100% {
              transform: scale(1);
              opacity: 1;
            }
          }
          
          @keyframes shine-sweep {
            0% {
              left: -100%;
              opacity: 0;
            }
            50% {
              opacity: 1;
            }
            100% {
              left: 100%;
              opacity: 0;
            }
          }
          
          .tutorial-button {
            animation: bounce-in 0.6s ease-out, pulse-glow 3s infinite;
          }
          
          .tutorial-button:hover {
            transform: translateY(-3px) scale(1.02);
            box-shadow: 0 8px 35px rgba(139, 92, 246, 0.5) !important;
            animation: pulse-glow 1.5s infinite;
          }
          
          .tutorial-button:hover .shine-overlay {
            animation: shine-sweep 0.8s ease-out;
          }
          
          .tutorial-button:active {
            transform: translateY(-1px) scale(0.98);
            transition: all 0.1s ease;
          }
          
          .tutorial-button:focus {
            outline: none;
            box-shadow: 0 8px 35px rgba(139, 92, 246, 0.5), 0 0 0 3px rgba(139, 92, 246, 0.4) !important;
          }
          
          .tutorial-button span {
            position: relative;
            z-index: 2;
          }
          
          .play-icon {
            position: relative;
            z-index: 2;
            transition: transform 0.3s ease;
          }
          
          .tutorial-button:hover .play-icon {
            transform: scale(1.1);
          }
        `
      }} />

      {/* Tutorial Button */}
      <button
        onClick={openPopup}
        className="tutorial-button"
        style={buttonStyles as React.CSSProperties}
      >
        {/* Shine animation overlay */}
        <div className="shine-overlay" style={shineStyles as React.CSSProperties} />
        
        {/* Play icon */}
        <div className="play-icon" style={playIconStyles} />
        
        {/* Button text */}
        <span>Watch Tutorial</span>
      </button>

      {/* Bootstrap Modal */}
      {showPopup && (
        <div 
          className="modal fade show d-block"
          style={{ 
            backgroundColor: 'rgba(0, 0, 0, 0.75)',
            zIndex: 1050
          }}
          onClick={closePopup}
        >
          <div 
            className="modal-dialog modal-xl modal-dialog-centered"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content">
              {/* Modal Header */}
              <div className="modal-header">
                <h5 className="modal-title">How to add and prioritize properties in Coralytics</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closePopup}
                  aria-label="Close"
                ></button>
              </div>
              
              {/* Modal Body */}
              <div className="modal-body p-0">
                <div style={{ 
                  position: 'relative', 
                  width: '100%', 
                  height: '70vh',
                  minHeight: '500px',
                  marginTop:"20px"
                }}>
                  <iframe 
                    src="https://app.supademo.com/embed/cmes6awfp4iq7v9kqzio94lrr?embed_v=2&utm_source=embed" 
                    loading="lazy" 
                    title="How to add and prioritize properties in Coralytics" 
                    allow="clipboard-write" 
                    frameBorder={0} 
                    allowFullScreen={true}
                    style={{ 
                      width: '100%', 
                      height: '100%',
                      border: 'none'
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default TutorialButton;